<template>
  <BaseModal>
    <template v-slot:title>{{ $t('contact_us.title') }}</template>
    <template v-slot:content>
      <div class="wrapper">
        <div class="input-wrapper">
          <label>{{ $t('contact_us.subj') }}</label>
          <input class="input" v-model="subject" />
        </div>
        <div class="input-wrapper">
          <label>{{ $t('contact_us.mess') }}</label>
          <textarea class="input" v-model="message"></textarea>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="modal-btn modal-btn--cancel" @click="$emit('close')">{{ $t('buttons.cancel') }}</div>
      <div class="modal-btn modal-btn--action" @click="sendMessage()">{{ $t('buttons.send') }}</div>
    </template>
  </BaseModal>
</template>

<script>
export default {
  name: 'LayoutContactModal',
  data() {
    return {
      subject: '',
      message: '',
    };
  },
  methods: {
    sendMessage() {
      console.log(this.subject, this.message);
      // todo
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 1.5rem;
}
.modal-btn {
  &--cancel {
    width: 50%;
    &:hover {
      color: $company-color;
    }
  }

  &--action {
    width: 50%;
    background-color: $company-color;
    color: white !important;

    &:hover {
      background-color: darken($company-color, 10%);
    }
  }
}
</style>
